import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { History, HistoryResponse } from './types'
import { RequestError } from '../../../../shared/errorResponse'

export const historyMounted = createEvent<string>()
export const historyReset = createEvent()

export const getHistoriesFailed = createEvent<RequestError | null>()

export const getHistories = fx<string, HistoryResponse>({
  method: 'GET',
  url: `/verification?where{"clientId":"1"}`,
})

export const $history = restore<History[]>(
  getHistories.doneData.map((doneData) => doneData.body.items),
  [],
).reset(historyReset)

export const $historiesError = restore<RequestError | null>(
  getHistoriesFailed,
  null,
).reset([historyMounted])

sample({
  clock: [historyMounted],
  fn: (id) => {
    return {
      url: `/verification?where={"clientId":"${id}"}&order=-createdAt`,
    }
  },
  target: [getHistories],
})

getHistories.fail.watch(({ error }) =>
  getHistoriesFailed({ code: error.status, message: error.body.message }),
)

getHistories.done.watch(() => getHistoriesFailed(null))
